module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-channellist"
  }, [_c('div', {
    staticClass: "kiwi-channellist-nav"
  }, [_c('a', {
    staticClass: "u-button kiwi-channellist-refresh",
    class: {
      'u-button-primary': _vm.listState === '',
        'u-button-secondary': _vm.listState === 'updating',
    },
    on: {
      "click": _vm.maybeUpdateList
    }
  }, [(_vm.listState === '') ? _c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-channellist-pagination"
  }, [_c('a', {
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" " + _vm._s(_vm.page + 1) + " / " + _vm._s(_vm.maxPages + 1) + " "), _c('a', {
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('form', {
    staticClass: "u-form kiwi-channellist-search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "u-input",
    attrs: {
      "placeholder": _vm.$t('do_search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.listState === '') ? _c('table', {
    key: _vm.last_updated,
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.paginated), function(channel) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "kiwi-channellist-users"
    }, [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(channel.num_users))]), _vm._v(" "), _c('a', {
      staticClass: "u-link",
      on: {
        "click": function($event) {
          _vm.joinChannel(channel.channel)
        }
      }
    }, [_vm._v(_vm._s(channel.channel))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(channel.topic))])])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c77b0e74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChannelList.vue
// module id = 508
// module chunks = 2